export interface IUnlockLoginRequest {

    Code: string;

}

export class UnlockLoginRequest implements IUnlockLoginRequest {

    Code: string;

}
